export let consumer;
export default {
  setConsumer(value) {
    consumer = value;
  }
};